export default "/images/vendor/@coreui/icons/svg/flag/cif-eg.svg?94307b03de39fdf8c95a61132a883be6";